import { create } from 'zustand';

type SnackbarSeverity = 'success' | 'error' | 'info' | 'warning';

const DEFAULT_AUTO_HIDE_DURATION = 4000;

interface ShowSnackbarOptions {
  severity?: SnackbarSeverity;
  autoHideDuration?: number | null;
}

interface SnackbarStore {
  open: boolean;
  message: string;
  severity: SnackbarSeverity;
  autoHideDuration: number | null;
  showSnackbar: (
    message: string,
    severityOrOptions?: SnackbarSeverity | ShowSnackbarOptions
  ) => void;
  hideSnackbar: () => void;
}

export const useSnackbarStore = create<SnackbarStore>(set => ({
  open: false,
  message: '',
  severity: 'success',
  autoHideDuration: DEFAULT_AUTO_HIDE_DURATION,
  showSnackbar: (message, severityOrOptions = 'success') => {
    const opts =
      typeof severityOrOptions === 'string'
        ? { severity: severityOrOptions }
        : severityOrOptions;
    set({
      open: true,
      message,
      severity: opts.severity ?? 'success',
      autoHideDuration:
        opts.autoHideDuration === undefined
          ? DEFAULT_AUTO_HIDE_DURATION
          : opts.autoHideDuration,
    });
  },
  hideSnackbar: () =>
    set({
      open: false,
      autoHideDuration: DEFAULT_AUTO_HIDE_DURATION,
    }),
}));
